import { diContainer, serviceNames } from '~setup/diContainer';
import { LoyaltyRepository } from '~repositories/LoyaltyRepository';

export class LoadLoyaltyInfoUseCase {
    private loyaltyRepository: LoyaltyRepository;

    constructor() {
        this.loyaltyRepository = diContainer.get(serviceNames.loyaltyRepository);
    }

    public async execute() {
        await this.loyaltyRepository.fetchLoyaltyInfo();
    }
}
